/* eslint-disable react-hooks/exhaustive-deps */
/* รายการโปรเจ็กต์บ้าน */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Flex, Input, Row, Segmented, Statistic, Table, Tag, Typography, message } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import StatusTag, { PROJECT_STATUS } from "../../../components/ak/StatusTag";
import { ProjectService, apiError } from "../../../service/Ak.service";
import { usePermission } from "../../../store/context/permission-context";
import { formatMoney } from "../../../utils/util";

const d = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-");

export default function ProjectAccess() {
  const navigate = useNavigate();
  const { can } = usePermission();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("ทั้งหมด");

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      ProjectService.list({ q: q || undefined, status: status === "ทั้งหมด" ? undefined : status }, { ignoreLoading: true })
        .then((r) => setRows(r.data?.data || []))
        .catch((e) => message.error(apiError(e)))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q, status]);

  const count = (s) => rows.filter((r) => r.status === s).length;

  const columns = [
    {
      title: "โปรเจ็กต์",
      dataIndex: "project_code",
      render: (v, r) => (
        <div>
          <Typography.Link strong onClick={() => navigate(`view/${v}`)}>
            {r.project_name}
          </Typography.Link>
          <div style={{ fontSize: 12, color: "#8c8c8c" }}>{v}</div>
        </div>
      ),
    },
    {
      title: "ลูกค้า",
      key: "cus",
      render: (_, r) => (
        <div>
          <div>{[r.prename, r.cus_name].filter(Boolean).join(" ")}</div>
          <div style={{ fontSize: 12, color: "#8c8c8c" }}>{r.cus_tel || ""}</div>
        </div>
      ),
    },
    { title: "แบบบ้าน", key: "model", render: (_, r) => (r.model_code ? <Tag>{r.model_code}</Tag> : "-") },
    { title: "สถานะ", dataIndex: "status", render: (v) => <StatusTag value={v} /> },
    { title: "มูลค่าสัญญา", dataIndex: "contract_value", align: "right", render: (v) => (v ? formatMoney(v, 0) : "-") },
    { title: "แผนงาน", key: "plan", render: (_, r) => (r.start_date ? `${d(r.start_date)} – ${d(r.end_date)}` : r.plan_days ? `${r.plan_days} วัน` : "-") },
    { title: "Support", dataIndex: "support_names", render: (v) => v || "-" },
    { title: "โฟร์แมน", dataIndex: "foreman_names", render: (v) => v || "-" },
    {
      title: "ใบเลือกวัสดุ",
      dataIndex: "selection_status",
      render: (v) => (v ? <StatusTag value={v} /> : <Tag>ยังไม่เริ่ม</Tag>),
    },
  ];

  return (
    <Card className="ak-card">
      <Flex justify="space-between" align="center" wrap="wrap" gap={8} className="mb-3">
        <div>
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            โปรเจ็กต์บ้าน
          </Typography.Title>
          <Typography.Text type="secondary">ลูกค้า · แบบบ้าน · สัญญา · ทีมผู้ดำเนินการ</Typography.Text>
        </div>
        {can("support_project", "add") && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("manage/new")}>
            สร้างโปรเจ็กต์
          </Button>
        )}
      </Flex>

      {status === "ทั้งหมด" && !q && (
        <Row gutter={12} className="mb-3">
          {["ร่าง", "ทำสัญญาแล้ว", "กำลังก่อสร้าง", "ส่งมอบแล้ว"].map((s) => (
            <Col xs={12} md={6} key={s}>
              <Card size="small" className="ak-stat" hoverable onClick={() => setStatus(s)}>
                <Statistic title={s} value={count(s)} />
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <Flex gap={8} wrap="wrap" className="mb-3">
        <Input allowClear prefix={<SearchOutlined />} placeholder="ค้นหา ชื่อโปรเจ็กต์ / ลูกค้า / เบอร์ / เลขสัญญา" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: 340 }} />
        <Segmented value={status} onChange={setStatus} options={["ทั้งหมด", ...PROJECT_STATUS]} />
      </Flex>

      <Table
        rowKey="project_code"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={rows}
        scroll={{ x: "max-content" }}
        onRow={(r) => ({ onDoubleClick: () => navigate(`view/${r.project_code}`) })}
        pagination={{ pageSize: 25, showTotal: (t) => `ทั้งหมด ${t} โปรเจ็กต์` }}
      />
    </Card>
  );
}
